import React from 'react'
import { DataContainer } from '../../components/dashboard'
import { BoxPlotOutlined, EuroCircleOutlined, LineChartOutlined, BarChartOutlined } from '@ant-design/icons'
import styles from './data-container.module.scss'
import PropTypes from 'prop-types'
const DashboardHeader = ({ values }) => {
    return (
        <div className={styles.dashboardHeader}>
            <DataContainer background={'#F3F8FE'} text={'Open Enquiries'} value={values?.open_enquiry} icon={<BoxPlotOutlined style={{ fontSize: '32px', color: '#6E98DC' }} />} />
            <DataContainer background={'#DAF3E0'} text={'Quotation Replied'} value={values?.quotation_replied} icon={<BarChartOutlined style={{ fontSize: '32px', color: '#61D373' }} />} />
            <DataContainer background={'#F4F3FB'} text={'Ongoing Project'} value={values?.ongoing_project} icon={<LineChartOutlined style={{ fontSize: '32px', color: '#747FEC' }} />} />
            <DataContainer background={'#FCF6EC'} text={'Pending Payment'} value={values?.pending_payment} icon={<EuroCircleOutlined style={{ fontSize: '32px', color: '#E8BB44' }} />} />
        </div>
    )
}

DashboardHeader.propTypes = {
    values: PropTypes.object

}
export default DashboardHeader